<template>
  <div class="accordion" :class="{ discreet }">
    <div class="card">
      <button
        type="button"
        :disabled="disabled"
        class="link no-outline card-header"
        data-toggle="collapse"
        :data-target="`#${id}.collapse`"
        @click="toggleAccordion()"
      >
        <slot name="header" />

        <h5 v-if="title" class="mb-0">
          {{ title }}
          <i v-if="loading" class="spinner spinner-border spinner-border-sm refresh-spinner" />
        </h5>
        <slot name="title" />

        <i v-if="!disabled" class="ml-auto fa" :class="[(flipArrows ? !collapsed : collapsed) ? 'fa-chevron-down' : 'fa-chevron-up']" />
      </button>

      <slot name="title-after-button" />

      <div
        v-show="!disabled"
        :id="id"
        ref="collapse"
        class="collapse"
        :class="{
          show: !startCollapsed,
        }"
      >
        <div class="card-body">
          <div
            :class="{
              'loading-overlay': loading,
            }"
          />
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

const props = defineProps<{
  title?: string
  startCollapsed?: boolean
  disabled?: boolean
  loading?: boolean
  discreet?: boolean
  state?: boolean
  flipArrows?: boolean
}>()
const emit = defineEmits<{ state: [value: { value: boolean }]; 'update:state': [state: boolean] }>()

const collapsed = ref(props.startCollapsed)
const id = '_' + Math.round(Math.random() * 8456093)

const toggleAccordion = () => {
  collapsed.value = !collapsed.value
  emit('state', {
    value: !collapsed.value,
  })

  emit('update:state', !collapsed.value)
}
</script>

<style lang="scss" scoped>
.discreet.accordion {
  box-shadow: unset;

  .card {
    border: none;
  }
}

.accordion {
  margin: 1em 0;
  box-shadow: #0002 0 0 5px;

  .card-header {
    margin-bottom: unset;
  }
}

button.link:focus {
  background-color: #fafafa;
}

.card {
  overflow: visible;
  .card-header {
    display: flex;
    text-align: left;

    &.button > i {
      color: red;
    }

    h5 {
      width: 100%;
    }

    i {
      text-align: right;
    }
  }

  .card-body {
    position: relative;
  }
}

.loading-overlay {
  position: absolute;
  z-index: 3;
  background-color: #fffa;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.fa {
  line-height: 1.2em;
}
</style>
